import { atom } from "jotai";
import { UserDto } from "@rinastyling/common";

export const userAtom = atom<(UserDto & { accessToken: string }) | null>(null);
export const loadingValidateUserReq = atom<boolean>(true);
